var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined/Minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 5 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2286 13.25L3.77143 13.25C3.34538 13.25 3 12.9142 3 12.5C3 12.0858 3.34538 11.75 3.77143 11.75L20.2286 11.75C20.6546 11.75 21 12.0858 21 12.5C21 12.9142 20.6546 13.25 20.2286 13.25Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.5661d30b9e8a876528620fbb3d54d572.svg";
export { ForwardRef as ReactComponent };